import { render, staticRenderFns } from "./trainerTable.vue?vue&type=template&id=48609d1a&scoped=true&"
import script from "./trainerTable.vue?vue&type=script&lang=js&"
export * from "./trainerTable.vue?vue&type=script&lang=js&"
import style0 from "./trainerTable.vue?vue&type=style&index=0&id=48609d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48609d1a",
  null
  
)

export default component.exports